var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPlaceholderXl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.5717 68.5713H54.8574V82.2856H68.5717V68.5713Z",
    fill: "#B73FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2856 27.4287H68.5713V41.143H82.2856V27.4287Z",
    fill: "#B73FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2866 54.8564H68.5723V68.5707H82.2866V54.8564Z",
    fill: "#B73FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2866 41.1436H68.5723V54.8578H82.2866V41.1436Z",
    fill: "#B73FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.142 41.1436H27.4277V54.8578H41.142V41.1436Z",
    fill: "#B73FFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5717 13.7139H54.8574V27.4282H68.5717V13.7139Z",
    fill: "#B73FFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8569 27.4287H41.1426V41.143H54.8569V27.4287Z",
    fill: "#B73FFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.142 13.7139H27.4277V27.4282H41.142V13.7139Z",
    fill: "#B73FFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8569 41.1436H41.1426V54.8578H54.8569V41.1436Z",
    fill: "#B73FFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8569 54.8564H41.1426V68.5707H54.8569V54.8564Z",
    fill: "#B73FFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.142 54.8564H27.4277V68.5707H41.142V54.8564Z",
    fill: "#B73FFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5717 41.1436H54.8574V54.8578H68.5717V41.1436Z",
    fill: "#B73FFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5717 54.8564H54.8574V68.5707H68.5717V54.8564Z",
    fill: "#B73FFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8569 68.5713H41.1426V82.2856H54.8569V68.5713Z",
    fill: "#B73FFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8569 13.7139H41.1426V27.4282H54.8569V13.7139Z",
    fill: "#B73FFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.143 68.5713H27.4287V82.2856H41.143V68.5713Z",
    fill: "#B73FFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5717 27.4287H54.8574V41.143H68.5717V27.4287Z",
    fill: "#B73FFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M41.143 27.4287H27.4287V41.143H41.143V27.4287Z",
    fill: "#B73FFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4282 27.4287H13.7139V41.143H27.4282V27.4287Z",
    fill: "#B73FFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4282 41.1436H13.7139V54.8578H27.4282V41.1436Z",
    fill: "#B73FFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4282 54.8564H13.7139V68.5707H27.4282V54.8564Z",
    fill: "#B73FFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M41.143 0H27.4287V13.7143H41.143V0Z",
    fill: "#B73FFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4282 13.7139H13.7139V27.4282H27.4282V13.7139Z",
    fill: "#B73FFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7143 27.4287H0V41.143H13.7143V27.4287Z",
    fill: "#B73FFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7143 41.1436H0V54.8578H13.7143V41.1436Z",
    fill: "#B73FFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7143 54.8564H0V68.5707H13.7143V54.8564Z",
    fill: "#B73FFF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4282 68.5713H13.7139V82.2856H27.4282V68.5713Z",
    fill: "#B73FFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M41.142 82.2861H27.4277V96.0004H41.142V82.2861Z",
    fill: "#B73FFF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8569 82.2861H41.1426V96.0004H54.8569V82.2861Z",
    fill: "#B73FFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5717 82.2861H54.8574V96.0004H68.5717V82.2861Z",
    fill: "#B73FFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2856 68.5713H68.5713V82.2856H82.2856V68.5713Z",
    fill: "#B73FFF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0004 54.8564H82.2861V68.5707H96.0004V54.8564Z",
    fill: "#B73FFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0004 41.1436H82.2861V54.8578H96.0004V41.1436Z",
    fill: "#B73FFF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0004 27.4287H82.2861V41.143H96.0004V27.4287Z",
    fill: "#B73FFF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2866 13.7139H68.5723V27.4282H82.2866V13.7139Z",
    fill: "#B73FFF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5717 0H54.8574V13.7143H68.5717V0Z",
    fill: "#B73FFF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8569 0H41.1426V13.7143H54.8569V0Z",
    fill: "#B73FFF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M70.995 58.6883H66.6082V49.9898H61.7134V54.2979H57.3427V58.6655H61.6784V64H52.8808V54.3455H43.5942V63.9861H34.7956V58.6854H39.1373V54.3256H34.7756V49.9769H29.8938V58.6466H25V45.0881H29.8317V40.2509H34.7525V36.3577H39.1513V32.004H43.5511V36.3121H52.8507V32H57.2976V36.326H61.6914V40.2171H66.5742V45.0613H71L70.995 58.6883ZM44.018 47.4714V42.6878H39.1954V47.4754L44.018 47.4714ZM52.9209 47.4535H57.7395V42.6988H52.9209V47.4535Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlaceholderXl);
export default __webpack_public_path__ + "static/media/user-placeholder-xl.de3cd525714e923bf6db69792e88c454.svg";
export { ForwardRef as ReactComponent };